"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotEnrolledVehicleError = void 0;
class NotEnrolledVehicleError extends Error {
    constructor(m) {
        if (!m) {
            m = 'Error due to disenrolling a vehicle which is not enrolled';
        }
        super(m);
    }
}
exports.NotEnrolledVehicleError = NotEnrolledVehicleError;
//# sourceMappingURL=NotEnrolledVehicleError.js.map